module.exports = __webpack_public_path__ + "img/clin-reg-sys.b6836528.png";